import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    enterAddress: {
        id: '_.auto_address.error.enter_address',
        defaultMessage: 'Please enter at least one address'
    },
    enterPostcode: {
        id: '_.auto_address.enter_postcode',
        defaultMessage: 'Enter your home postcode'
    },
    enterPostcodeReason: {
        id: '_.auto_address.enter_postcode_reason',
        defaultMessage:
            'We need your home address in order to run credit and identity checks'
    },
    somethingWrong: {
        id: '_.auto_address.something_went_wrong',
        defaultMessage: 'Oops. Something went wrong'
    },
    somethingWrongDescription: {
        id: '_.auto_address.something_went_wrong_description',
        defaultMessage: 'Please try to enter your address manually'
    },
    invalidPostcode: {
        id: '_.auto_address.invalid_postcode',
        defaultMessage: 'Oops. Your postcode is not valid'
    },
    invalidPostcodeReason: {
        id: '_.auto_address.invalid_postcode_reason',
        defaultMessage:
            "Make sure you enter your full home postcode and click search. If you're having trouble finding your address, please enter it manually"
    },
    chooseAddress: {
        id: '_.auto_address.choose_address',
        defaultMessage: 'Choose your address (or'
    },
    enterManually: {
        id: '_.auto_address.enter_manually',
        defaultMessage: 'enter manually)'
    },
    enterAddressManually: {
        id: '_.auto_address.enter_address_manually',
        defaultMessage: 'Enter address manually'
    }
});
